import api from './api'

const newsletterService = {
  getNewsletters: ({ search = '', skipCount = 0, totalCount = 10 }) =>
    api.post('/api/Newsletters/getall', {
      input: {
        search,
        skipCount,
        totalCount
      }
    })
}

export default newsletterService
